/* eslint-disable */
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Custom components
import TenantContext from '@/context/TenantContext/TenantContext';

// Types
import { ITenantState, ITenantStatePreParsed } from '@/@types/common';

type TenantProviderProps = {
  children: JSX.Element | JSX.Element;
};

const TenantProvider: FunctionComponent<TenantProviderProps> = (
  props: React.PropsWithChildren<TenantProviderProps>
) => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [tenant, setTenant] = useState<ITenantState>({
    tenantId: 0,
    tenantName: '',
    publicToken: '',
    publicUsername: '',
    mapSettings:{
      default_extent: [],
      max_extent: [],
      initial_view_center: [0,0],
      initial_view_zoom: 0,
      map_min_view_zoom: 0,
      map_max_view_zoom: 0,
    },
    tenantTheme: {
      primary_main: '',
      primary_dark: '',
      primary_light: '',
      secondary_main: '',
      secondary_dark: '',
      secondary_light: '',
      crest: undefined,
      crest_type: undefined,
      background_image: undefined,
      background_image_type: undefined,
      sidebar_crest: undefined,
      sidebar_crest_type: undefined,
      footer_logo: undefined,
      footer_logo_type: undefined,
      login_logo: undefined,
      login_logo_type: undefined
    },
    canSearch: false,
    canAttributeSearch: false,
    canAttributeSearchPublic: false,
    projectionSettings: null,
    languages: [{"code": "hr", "title": "hr"}, {"code": "en", "title": "en"}],
    defaultLanguage: null,
    ena: null
  });

  const setTenantData = (data: ITenantStatePreParsed): void => {
    const { tenant_id, name_ttoken, public_token, public_username, theme, map_settings, can_search, can_attribute_search, can_attribute_search_public, projection_settings, languages, default_language, ena } = data;

    setLoaded(true);
    setTenant({
      tenantId: tenant_id,
      tenantName: t(name_ttoken),
      publicToken: public_token,
      publicUsername: public_username, 
      tenantTheme: theme,
      mapSettings: {
        max_extent: map_settings.map_max_extent,
        default_extent: map_settings.map_default_extent,
        initial_view_center: map_settings.map_initial_view_center,
        initial_view_zoom: map_settings.map_initial_view_zoom,
        map_min_view_zoom: map_settings.map_min_view_zoom,
        map_max_view_zoom: map_settings.map_max_view_zoom
      },
      canSearch: can_search,
      canAttributeSearch: can_attribute_search,
      canAttributeSearchPublic: can_attribute_search_public,
      projectionSettings: projection_settings,
      languages: languages,
      defaultLanguage: default_language ?? null,
      ena: ena ? { hideZapisnikIfNoFilename: ena.hide_zapisnik_if_no_filename } : null
    });
  };

  // TODO eslint suggests wraping this in useMemo
  const providerValue = {
    loaded,
    id: tenant.tenantId,
    name: tenant.tenantName,
    publicToken: tenant.publicToken,
    publicUsername: tenant.publicUsername,
    tenantTheme: tenant.tenantTheme,
    mapSettings: tenant.mapSettings,
    setTenantData,
    canSearch: tenant.canSearch,
    canAttributeSearch: tenant.canAttributeSearch,
    canAttributeSearchPublic: tenant.canAttributeSearchPublic,
    projectionSettings: tenant.projectionSettings,
    languages: tenant.languages,
    defaultLanguage: tenant.defaultLanguage,
    ena: tenant.ena
  };

  return (
    <TenantContext.Provider value={providerValue}>
      {props.children}
    </TenantContext.Provider>
  );
};

export default TenantProvider;
